import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiArrowRight } from 'react-icons/fi';
import { getLocalized } from '../../utils/i18nHelpers';
import { getImageUrl } from '../../utils/imageHelpers';
import { SlideUp, StaggerContainer, StaggerItem } from '../animations';

const GiftCollectionsSection = ({ settings }) => {
    const { i18n, t } = useTranslation();

    const defaultCollections = [
        {
            id: 1,
            title: t('home.giftCollections.item1Title'),
            desc: t('home.giftCollections.item1Desc'),
            image: "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?auto=format&fit=crop&q=80&w=800",
            link: "/products?category=anneler-gunu"
        },
        {
            id: 2,
            title: t('home.giftCollections.item2Title'),
            desc: t('home.giftCollections.item2Desc'),
            image: "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&q=80&w=800",
            link: "/products?category=sevgililer-gunu"
        },
        {
            id: 3,
            title: t('home.giftCollections.item3Title'),
            desc: t('home.giftCollections.item3Desc'),
            image: "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?auto=format&fit=crop&q=80&w=800",
            link: "/products?category=evlilik-yildonumu"
        }
    ];

    // Use admin settings if available, otherwise fallback to defaults
    const collections = settings?.tripleGrid?.length === 3 && settings.tripleGrid.some(item => item.image) 
        ? settings.tripleGrid.map((item, index) => ({
            id: item._id || index,
            title: getLocalized(item, 'title', i18n.language) || defaultCollections[index].title,
            desc: getLocalized(item, 'subtitle', i18n.language) || defaultCollections[index].desc,
            image: item.image ? getImageUrl(item.image) : defaultCollections[index].image,
            link: item.link || defaultCollections[index].link,
            linkText: getLocalized(item, 'linkText', i18n.language) || 'KEŞFET'
        }))
        : defaultCollections.map(item => ({...item, linkText: 'KEŞFET'}));

    return (
        <section className="py-16 md:py-24 bg-white">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-12">
                {/* Header */}
                <SlideUp className="text-center mb-16">
                    <span className="block text-[#287968] text-[11px] font-bold tracking-[0.25em] uppercase mb-4">{t('home.giftCollections.subtitle')}</span>
                    <h2 className="text-4xl md:text-5xl font-serif text-[#4a4a4a] mb-6">
                        {t('home.giftCollections.title', 'Hediye Koleksiyonları')}
                    </h2>
                    <div className="w-12 h-[1px] bg-gray-300 mx-auto"></div>
                </SlideUp>

                {/* Grid */}
                <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
                    {collections.map((item) => (
                        <StaggerItem key={item.id} className="h-full">
                        <Link
                            to={item.link}
                            className="group relative block aspect-square overflow-hidden bg-gray-100 h-full"
                        >
                            <img
                                src={item.image}
                                alt={item.title}
                                className="w-full h-full object-cover transition-transform duration-[2000ms] group-hover:scale-105"
                            />

                            {/* Dark gradient overlay */}
                            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-90" />

                            {/* Content */}
                            <div className="absolute bottom-8 left-8 right-8">
                                <span className="block text-white/70 text-[9px] tracking-[0.2em] uppercase font-semibold mb-2">
                                    MASHOW
                                </span>
                                <h3 className="text-white text-xl md:text-2xl font-bold tracking-wider uppercase mb-2">
                                    {item.title}
                                </h3>
                                <p className="text-white/80 text-xs md:text-sm font-light mb-6">
                                    {item.desc}
                                </p>
                                
                                <span className="inline-flex items-center gap-2 text-[10px] font-bold tracking-[0.2em] text-white uppercase border-b border-white/30 pb-1 group-hover:border-white transition-colors">
                                    {item.linkText} <FiArrowRight />
                                </span>
                            </div>
                        </Link>
                        </StaggerItem>
                    ))}
                </StaggerContainer>
            </div>
        </section>
    );
};

export default GiftCollectionsSection;
